import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B04aInventoryInfoPage } from '../b04a-inventory-info/b04a-inventory-info';
import { B04InventoryManagementPage } from '../b04-inventory-management/b04-inventory-management';
import { B04bInventoryAddPage } from '../b04b-inventory-add/b04b-inventory-add';

/**
 * Generated class for the B04cInventoryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface inventoryInfo{
  BRANCH_ID: number;
  INVENTORY_ID: number;
  ITEM_DESC: string;
  COST: number; 
  SELLING_PRICE: number; 
  INVENTORY_ACTIVE: string;  
  INVENTORY_TYPE_ID: number;
  NAME: string; 
}

interface invenTypeInfo{
  INVENTORY_TYPE_ID: number;
  NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b04c-inventory',
  templateUrl: 'b04c-inventory.html',
})
export class B04cInventoryPage {

  loading: any;
  Status: any;
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  invenTypeArr: invenTypeInfo[] = [];
  invenTypeItems: invenTypeInfo[] = [];
  public errorMessage: any = "";
  public searchMessage:any ="";
  inventoryType: any = "";
  inventoryDesc:any = "";
  mybranchid:any;
  GRP_ID: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {

    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.mybranchid = sessionStorage.getItem('userbranchid');
    let sortby= "No";
    let sorttype= "No";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
                
    if(this.GRP_ID=="1") {            //system admin
      temp_tbl = ["All"];
      temp_column = ["All"];
      temp_value = ["All"];
    }
    if(this.mybranchid != "null")
    {
      temp_tbl = ["INVENTORY"];
      temp_column = ["BRANCH_ID"];
      temp_value = [this.mybranchid];
    }
    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["INVENTORY_TYPE_ID"];
    let fktbl = ["INVENTORY_TYPE"];
    let fkkey = ["INVENTORY_TYPE_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    console.log(json_data);
    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        let Records = result["Records"];
        this.inventoryArr = Records;
        this.inventoryItems = this.inventoryArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
      
      let tbl = ["All"];
      let column = ["All"];
      let value = ["All"];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];
    
      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");

      this.serviceapi.readdata(json_data,"INVENTORY_TYPE","1","1").then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        if (this.Status == '1'){
          
          let Records = result["Records"];
          this.invenTypeArr = Records;
          this.invenTypeItems = this.invenTypeArr;
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
      });
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B04cInventoryPage');
  }

  goToEdit(ID){
    this.navCtrl.push(B04aInventoryInfoPage, {paramID: ID});          //Inventory ID
  }

  goToAdd(){
    this.navCtrl.push(B04bInventoryAddPage);
  }

  goTo(){
    this.navCtrl.push(B04InventoryManagementPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  clearItem(){
    this.inventoryDesc = "";
    this.inventoryType = "";
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
    this.inventoryItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.inventoryDesc!=""){
      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["INVENTORY"];
        temp_column = ["ITEM_DESC"];
        temp_value = [this.inventoryDesc];
      }
      this.inventoryType="";
    }
    else if (this.inventoryType!=""){
      temp_tbl = ["INVENTORY_TYPE"];
      temp_column = ["INVENTORY_TYPE_ID"];
      temp_value = [this.inventoryType];
      this.inventoryDesc="";
    }
    else {

      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["All"];
        temp_column = ["All"];
        temp_value = ["All"];
      }
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["INVENTORY_TYPE_ID"];
    let fktbl = ["INVENTORY_TYPE"];
    let fkkey = ["INVENTORY_TYPE_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    console.log(json_data);
    this.serviceapi.readdata(json_data,"INVENTORY","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        let Records = result["Records"];
        this.inventoryArr = Records;
        this.inventoryItems = this.inventoryArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
      
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04c-inventory/b04c-inventory.ts